import { styled } from '@styles/config'

export const Button = styled('button', {
  borderRadius: 'none',
  fontWeight: '600',
  border: 'none',
  cursor: 'pointer',
})
